var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time-rem" }, [
    _c(
      "svg",
      {
        attrs: {
          viewBox: "0 0 160 160",
          width: _vm.width || 160,
          height: _vm.height || 160
        }
      },
      [
        _c("circle", {
          staticStyle: {
            stroke: "#ccc",
            "stroke-width": "4",
            fill: "transparent"
          },
          attrs: { cx: "80", cy: "80", r: "78" }
        }),
        _vm._v(" "),
        _vm.expiryPeriodPercent == 100
          ? _c("circle", {
              staticStyle: {
                stroke: "#457371",
                "stroke-width": "4",
                fill: "transparent"
              },
              attrs: { cx: "80", cy: "80", r: "78" }
            })
          : _c("path", {
              staticStyle: {
                stroke: "#457371",
                "stroke-width": "4",
                fill: "transparent"
              },
              attrs: {
                d:
                  "M 80 2 A 78 78 0 " +
                  (_vm.expiryPeriodPercent > 50 ? "1" : "0") +
                  " 1 " +
                  (80 +
                    Math.cos(
                      ((90 - _vm.expiryPeriodPercent * 3.6) / 180) * 3.14159265
                    ) *
                      78) +
                  " " +
                  (80 -
                    Math.sin(
                      ((90 - _vm.expiryPeriodPercent * 3.6) / 180) * 3.14159265
                    ) *
                      78)
              }
            })
      ]
    ),
    _vm._v(" "),
    _vm.expiryPeriodPercent
      ? _c("span", [
          _vm._v(_vm._s(_vm.expiryPeriodPercent)),
          _c("em", [_vm._v("%")])
        ])
      : _c("span", [_vm._v("-")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }